// Keep the fallback in sync with package.json "version" when bumping locally
// without Ansible. Prefer REACT_APP_WEB_VERSION at build time so the client
// never bundles the full package.json manifest.
export const WEB_VERSION = process.env.REACT_APP_WEB_VERSION || "3.4.0";
export const WEB_GIT_SHA = process.env.REACT_APP_GIT_SHA || "";
export const WEB_GIT_COMMIT_TIME = process.env.REACT_APP_GIT_COMMIT_TIME || "";

export const hasWebBuildIdentity = () =>
  Boolean(WEB_GIT_SHA || WEB_GIT_COMMIT_TIME);

/**
 * @param {{ unavailable?: string, commit?: string, date?: string }} [labels]
 */
export const formatWebBuildTooltip = (labels = {}) => {
  const unavailable = labels.unavailable || "Commit info unavailable";
  const commitLabel = labels.commit || "Commit";
  const dateLabel = labels.date || "Date";

  if (!hasWebBuildIdentity()) {
    return unavailable;
  }
  const lines = [];
  if (WEB_GIT_SHA) lines.push(`${commitLabel}: ${WEB_GIT_SHA}`);
  if (WEB_GIT_COMMIT_TIME) lines.push(`${dateLabel}: ${WEB_GIT_COMMIT_TIME}`);
  return lines.join("\n");
};
